import { Link } from 'react-router-dom';

const columns = [
  {
    title: '浏览',
    links: [
      { to: '/', label: '首页' },
      { to: '/comics', label: '漫画库' },
      { to: '/reading-modes', label: '阅读模式' },
    ],
  },
  {
    title: '支持',
    links: [
      { to: '/faq', label: '常见问题' },
      { to: '/about', label: '关于我们' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">漫蛙漫画网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注优化漫画阅读体验的在线平台，提供高清原图、双页浏览、夜间模式、缩放设置与滚动阅读等多种阅读模式，让每一格画面都清晰舒适。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                rel="nofollow"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:bg-background-50"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                rel="nofollow"
                aria-label="微信公众号"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:bg-background-50"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                rel="nofollow"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:bg-background-50"
              >
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-7">
            <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
              {columns.map((col) => (
                <div key={col.title}>
                  <h3 className="text-sm font-semibold text-foreground-950">{col.title}</h3>
                  <ul className="mt-4 space-y-3">
                    {col.links.map((link) => (
                      <li key={link.to}>
                        <Link
                          to={link.to}
                          className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                        >
                          {link.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
              <div>
                <h3 className="text-sm font-semibold text-foreground-950">联系方式</h3>
                <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                  <li>
                    <a
                      href="mailto:hello@manwa-comic.example"
                      className="flex items-center gap-2 transition-colors hover:text-primary-600"
                    >
                      <i className="ri-mail-line"></i>
                      hello@manwa-comic.example
                    </a>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-time-line"></i>
                    每日 9:00 - 23:00 在线
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 漫蛙漫画网 · 用心优化每一页阅读体验
          </p>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <Link to="/about" className="transition-colors hover:text-primary-600">内容原则</Link>
            <Link to="/faq" className="transition-colors hover:text-primary-600">帮助中心</Link>
            <Link to="/about" className="transition-colors hover:text-primary-600">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}